export default "__VITE_ASSET__DrUBV_nq__"